function removeFunction(id) {
  return function() {
    var parent = this.parentNode;
    for (var i in this.__transition) if (+i !== id) return;
    if (parent) parent.removeChild(this);
  };
}

export default function() {
  return this.on("end.remove", removeFunction(this._id));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-transition/src/transition/remove.js
// module id = 2024
// module chunks = 0